import { ReactNode } from 'react';

import { Divider, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { TooltipProps } from 'recharts/types/component/Tooltip';

import { primaryColors } from '~components/theme/styles/colors';
import { columnGap, defaultBackground } from '~components/theme/styles/mixins';

export const GraphToolTip = ({
  timeFormat = 'MMMM Do YYYY h:mm',
  active,
  payload,
  children,
}: TooltipProps<ValueType, NameType> & { timeFormat?: string; children: ReactNode }) => {
  if (active && payload && payload.length) {
    const { timestamp } = payload[0].payload;

    return (
      <Grid
        sx={{
          padding: '24px',
          ...defaultBackground,
          ...columnGap(16),
          width: '280px',
          backdropFilter: 'blur(12.5px)',
        }}
      >
        <Typography sx={{ color: primaryColors[400] }} variant="label3">
          {moment(timestamp).utc().format(timeFormat)}
        </Typography>
        <Divider sx={{ margin: 0 }} />
        {children}
      </Grid>
    );
  }

  return null;
};
